export const environment = {
  production: false,
  // apiUrl: 'https://z8iyhlg3q0.execute-api.us-west-1.amazonaws.com/production'
  // apiUrl: 'https://1lxhnumzaa.execute-api.us-west-2.amazonaws.com/qa'
  apiUrl:"https://papapi.dev.dctinc.net",
  // apiUrl: "https://7jrbbhbjna.execute-api.us-east-1.amazonaws.com/prod",  
  accessKey: 'AKIA3IIV2AWGVGHEXEES',
  secretAccessKey: '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',
  region: 'us-east-1',
  bucket: 'pap-prod-content',
  micrositeUrl:"https://papmicrosite.dev.dctinc.net/",
};
